import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import PublicNavbar from "../components/PublicNavbar";
import SiteFooter from "../components/SiteFooter";
import { prefetchCollectionsIndex } from "../utils/collectionsData";
import { prefetchPortfolioIndex } from "../utils/portfolioData";
import "./PublicLayout.css";

export default function PublicLayout() {
  useEffect(() => {
    let idleId;
    let timeoutId;
    const run = () => {
      prefetchCollectionsIndex();
      prefetchPortfolioIndex();
    };
    if (typeof window !== "undefined") {
      if (typeof window.requestIdleCallback === "function") {
        idleId = window.requestIdleCallback(run, { timeout: 2500 });
      } else {
        timeoutId = window.setTimeout(run, 1200);
      }
    }
    return () => {
      if (idleId != null && typeof window.cancelIdleCallback === "function") {
        window.cancelIdleCallback(idleId);
      }
      if (timeoutId != null) window.clearTimeout(timeoutId);
    };
  }, []);

  return (
    <div className="public-root">
      <PublicNavbar />
      <main className="public-main" id="main-content">
        <Outlet />
      </main>
      <SiteFooter />
    </div>
  );
}
